import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../environments/test.environment';
import { AuthService } from '../services/auth.service';
import { SKIP_DSDN_AUTH } from './auth-http-context';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return next(request);
  }

  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const targetsDsdnApi = request.url.startsWith(environment.apiBaseUrl);
  const alreadyAuthorized = request.headers.has('Authorization');
  const skipsDsdnAuth = request.context.get(SKIP_DSDN_AUTH);

  const authenticatedRequest = token && targetsDsdnApi && !alreadyAuthorized && !skipsDsdnAuth
    ? request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      })
    : request;

  return next(authenticatedRequest).pipe(
    catchError(error => {
      // Only an application-token failure invalidates the local DSDN session.
      if (
        error.status === 401
        && token
        && targetsDsdnApi
        && !alreadyAuthorized
        && !skipsDsdnAuth
      ) {
        authService.logout();
        void router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
